// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-ok[data-v-403c116d]{color:#000}.color-critical[data-v-403c116d]{color:#db0000}.number[data-v-403c116d]{font-size:65px;line-height:1cap;margin:4px}.counter-title[data-v-403c116d]{font-size:10px;font-weight:400;fill:#666}", ""]);
// Exports
module.exports = exports;
